import { useDashboardIdentity } from './useDashboardIdentity';
import { useQuery } from '@tanstack/react-query';
import type { SessionTrendsResponse } from '@evi/shared';
import { fetchSessionTrends } from '@/lib/api';

/**
 * Session trends widget data hook. Live: session events refetch it
 * through LiveUpdatesProvider; no poll.
 */
export function useSessionTrends() {
  const identity = useDashboardIdentity();
  return useQuery<SessionTrendsResponse>({
    queryKey: ['dashboard', identity, 'session-trends'],
    queryFn: () => fetchSessionTrends(),
    staleTime: 5 * 60 * 1000,
  });
}
